import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BankingPartnerTable from "../../components/AdminPortal/BankingPartnerDetails/BankingPartnerTable";
import BankingPatnerDashboard from "../../components/AdminPortal/BankingPartnerDetails/BankingPatnerDashboard";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import "../../global.css";
import { bankingPartnerAPI } from "../../services/AdminPortal/api";
const BankingPartner = () => {
  const { sidebarExpanded, isMobile } = useSidebar();
  const navigate = useNavigate();
  const [selectedAll, setSelectedAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [bankingPartners, setBankingPartners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("dashboard");
  useEffect(() => {
    fetchBankingPartners();
  }, []);

  const fetchBankingPartners = async () => {
    try {
      setLoading(true);
      const response = await bankingPartnerAPI.getAll();
      if (response.success !== true) {
        throw new Error("Failed to fetch banking partners");
      }
      const transformedData = response.data.map((partner) => ({
        name: partner.bankName,
        category: partner.bankCategory,
        assignedFiles: partner.assignedFiles || "0",
        processedFiles: partner.processedFiles || "0",
        pendingFiles: partner.pendingFiles || "0",
        approvalRate: partner.processingRate || partner.approvalRate || "0%",
        processingTime: partner.processingTime || "0 days",
        subText: partner.branchName,
        id: partner._id,
        status: partner.status,
        representative: partner.representative,
        loanManagement: partner.loanManagement,
        compliance: partner.compliance,
        branchIFSCCode: partner.branchIFSCCode,
        bankAddress: partner.bankAddress,
      }));

      setBankingPartners(transformedData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleViewPartner = (partnerIndex) => {
    navigate(`${partnerIndex}`);
  };

  const handleSelectAll = () => {
    setSelectedAll(!selectedAll);
    if (!selectedAll) {
      setSelectedRows(bankingPartners.map((_, index) => index));
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxChange = (index) => {
    const updatedSelection = selectedRows.includes(index)
      ? selectedRows.filter((i) => i !== index)
      : [...selectedRows, index];
    setSelectedRows(updatedSelection);
    setSelectedAll(updatedSelection.length === bankingPartners.length);
  };

  const filteredPartners = bankingPartners.filter((partner) =>
    partner.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  return (
    <div
      className="min-h-screen bg-black text-white   mt-12"
      style={{
        marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
        width: isMobile
          ? "100%"
          : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
      }}
    >
      <TopNavbar />
      <div className="p-4 md:p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-xl">Banking Partners</h1>
          <button
            className="px-4 py-2 bg-[#FFCA20] text-black rounded-lg text-sm font-medium flex items-center gap-2"
            onClick={() => navigate("add-partners")}
          >
            <Plus size={16} />
            Add Banking Partner
          </button>
        </div>
        <div className="tab-strip-border overflow-x-auto">
          <div className="flex">
            <button
              onClick={() => setActiveTab("dashboard")}
              className={`tab-button ${
                activeTab === "dashboard"
                  ? "active-tab-border" // Apply the active border class
                  : "inactive-tab" // Apply inactive tab class
              }`}
            >
              Dashboard
            </button>
            <button
              onClick={() => setActiveTab("bankingPartnerList")}
              className={`tab-button ${
                activeTab === "bankingPartnerList"
                  ? "active-tab-border" // Apply the active border class
                  : "inactive-tab" // Apply inactive tab class
              }`}
            >
              Banking Partner List
            </button>
          </div>
        </div>
      </div>
      {activeTab === "dashboard" ? (
        <BankingPatnerDashboard />
      ) : (
        <BankingPartnerTable />
      )}
    </div>
  );
};

export default BankingPartner;
